import { useEffect } from "react";

const ZOOM_URL = "https://us06web.zoom.us/j/85154394953?pwd=FjuNYGRtjGhAr4zWSUh0MfAffB8iEG.1";

export default function Join() {
  useEffect(() => {
    window.location.replace(ZOOM_URL);
  }, []);

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-ink text-cream" data-testid="join-redirect">
      <div className="text-center">
        <p className="overline mb-4">#AskTasha</p>
        <p className="font-serif text-2xl text-cream">Opening Zoom…</p>
        <p className="mt-4 font-sans text-sm text-cream/50">
          If nothing happens,{" "}
          <a href={ZOOM_URL} className="text-gold underline-offset-2 hover:underline">tap here to join</a>.
        </p>
      </div>
    </div>
  );
}
